import styled from "styled-components";

export const ChartTypeMenuContainer = styled.div`
  width: 375px;
  padding-bottom: 25px;
  max-height: 90vh;
  overflow-y: auto;
`;
export const ChartTypeButton = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  height: auto;
  border-radius: 4px;
  cursor: pointer;
  color: #041c2c;
  font-weight: var(--fontWeightMedium);
  font-size: 12px;

  &.isSelected {
    background: rgba(var(--color-shadow-rgb), 0.3);
    color: #041c2c;

    svg {
      color: var(--color-primary);
    }
  }

  &.isAvailable:hover {
    background: rgba(var(--color-shadow-rgb), 0.3);

    svg {
      color: var(--color-primary);
    }
  }

  &.readonlyButton {
    cursor: not-allowed;
    color: #ccc;
    opacity: 0.5;

    svg,
    &:hover svg {
      color: #ccc;
    }
  }

  span {
    margin-top: 3px;
  }

  svg {
    color: #a2aaad;
    transition: color var(--duration-short);
  }

  &:hover {
    background: rgba(var(--color-shadow-rgb), 0.3);

    svg {
      color: var(--color-primary);
    }
  }
`;
